"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormComboBoxMenu", {
    enumerable: true,
    get: function() {
        return FormComboBoxMenu;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormComboBoxContext = require("../FormComboBoxContext");
const _Theme = require("../../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormComboBoxMenu = (param)=>{
    let { children, className = "", noBorder = false, noShadow = false, height, maxHeight, showWhenEmpty = false, ...props } = param;
    const { focused, floating, items } = (0, _react.useContext)(_FormComboBoxContext.FormComboBoxContext);
    const { colors, borderRadius } = (0, _Theme.useTheme)();
    var _floating_y;
    // This solution reacts to the browser height. I decided to give some margin, so I start calulating from 95% of the height. This is a bit hacky, but it works pretty well.
    const calculatedMaxHeight = maxHeight === "calculated" ? "calc(95% - ".concat((_floating_y = floating === null || floating === void 0 ? void 0 : floating.y) !== null && _floating_y !== void 0 ? _floating_y : 0, "px)") : maxHeight;
    var _floating_strategy, _floating_x, _floating_y1, _floating_strategy1, _floating_x1, _floating_y2, _floating_strategy2, _floating_x2, _floating_y3;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, items.length === 0 && !showWhenEmpty || !focused ? null : /*#__PURE__*/ _react.default.createElement("div", {
        ...props,
        ref: floating === null || floating === void 0 ? void 0 : floating.floating,
        className: _style.default.dynamic([
            [
                "cf62dead536a9696",
                [
                    (_floating_strategy = floating === null || floating === void 0 ? void 0 : floating.strategy) !== null && _floating_strategy !== void 0 ? _floating_strategy : "absolute",
                    (_floating_x = floating === null || floating === void 0 ? void 0 : floating.x) !== null && _floating_x !== void 0 ? _floating_x : 0,
                    (_floating_y1 = floating === null || floating === void 0 ? void 0 : floating.y) !== null && _floating_y1 !== void 0 ? _floating_y1 : 0,
                    colors.white,
                    !noBorder ? "1px solid ".concat(colors.border) : "",
                    borderRadius,
                    noShadow ? "none" : "0px 8px 24px rgba(0, 0, 0, 0.25)",
                    height !== null && height !== void 0 ? height : "auto",
                    calculatedMaxHeight !== null && calculatedMaxHeight !== void 0 ? calculatedMaxHeight : "none",
                    height != null || maxHeight != null ? "auto" : "visible"
                ]
            ]
        ]) + " " + (className || "")
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "cf62dead536a9696",
        dynamic: [
            (_floating_strategy1 = floating === null || floating === void 0 ? void 0 : floating.strategy) !== null && _floating_strategy1 !== void 0 ? _floating_strategy1 : "absolute",
            (_floating_x1 = floating === null || floating === void 0 ? void 0 : floating.x) !== null && _floating_x1 !== void 0 ? _floating_x1 : 0,
            (_floating_y2 = floating === null || floating === void 0 ? void 0 : floating.y) !== null && _floating_y2 !== void 0 ? _floating_y2 : 0,
            colors.white,
            !noBorder ? "1px solid ".concat(colors.border) : "",
            borderRadius,
            noShadow ? "none" : "0px 8px 24px rgba(0, 0, 0, 0.25)",
            height !== null && height !== void 0 ? height : "auto",
            calculatedMaxHeight !== null && calculatedMaxHeight !== void 0 ? calculatedMaxHeight : "none",
            height != null || maxHeight != null ? "auto" : "visible"
        ]
    }, "div.__jsx-style-dynamic-selector{position:".concat((_floating_strategy2 = floating === null || floating === void 0 ? void 0 : floating.strategy) !== null && _floating_strategy2 !== void 0 ? _floating_strategy2 : "absolute", ";left:").concat((_floating_x2 = floating === null || floating === void 0 ? void 0 : floating.x) !== null && _floating_x2 !== void 0 ? _floating_x2 : 0, "px;top:").concat((_floating_y3 = floating === null || floating === void 0 ? void 0 : floating.y) !== null && _floating_y3 !== void 0 ? _floating_y3 : 0, "px;background:").concat(colors.white, ";border:").concat(!noBorder ? "1px solid ".concat(colors.border) : "", ";-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, ";-webkit-box-shadow:").concat(noShadow ? "none" : "0px 8px 24px rgba(0, 0, 0, 0.25)", ";-moz-box-shadow:").concat(noShadow ? "none" : "0px 8px 24px rgba(0, 0, 0, 0.25)", ";box-shadow:").concat(noShadow ? "none" : "0px 8px 24px rgba(0, 0, 0, 0.25)", ";height:").concat(height !== null && height !== void 0 ? height : "auto", ";max-height:").concat(calculatedMaxHeight !== null && calculatedMaxHeight !== void 0 ? calculatedMaxHeight : "none", ";overflow:").concat(height != null || maxHeight != null ? "auto" : "visible", ";z-index:2}")));
};

//# sourceMappingURL=FormComboBoxMenu.js.map